var exports = {
  "k": "x04b3a21e--0b0d5b--container",
};

module.exports = exports;
